import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
export const TableCell = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, style, width, minWidth, ...restProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        ref: forwardedRef,
        className: tailwindMerge("table-cell w-full select-none items-center truncate p-4", className),
        style: {
            flex: width ? "1 0 ".concat(width, "px") : "1 1 100%",
            minWidth: minWidth || width ? "".concat(minWidth, "px") : "unset",
            ...style
        },
        ...restProps
    });
});
TableCell.displayName = "TableCell";
